import { useMutation, useQueryClient } from '@tanstack/react-query';

import { parseApiError } from '@cast/api-client';
import { notify } from '@cast/design-system';
import { apiClient } from '@cast/infrastructure-api';

import { getNodeQueryKey } from 'hooks/queries/nodes/useNodeQuery';
import { getNodesQueryKey } from 'hooks/queries/nodes/useNodesQuery';

export const useInterruptNodeMutation = (clusterId: string) => {
  const queryClient = useQueryClient();

  const handleError = (error: undefined) => {
    notify.error(
      parseApiError(error, 'Failed to initiate Spot Instance interrupt.')
    );
  };

  return useMutation({
    mutationFn: (nodeId: string) => {
      return apiClient.autoscaler.simulateSpotInterruption({
        clusterId,
        body: { nodeId },
      });
    },
    onSuccess: (_, nodeId) => {
      queryClient.invalidateQueries({
        queryKey: getNodesQueryKey({ clusterId }),
      });
      queryClient.invalidateQueries({
        queryKey: getNodeQueryKey({ clusterId, nodeId }),
      });
      notify.success(
        'Node interrupt simulation initiated. \n (Usually, it takes just a few minutes)'
      );
    },
    onError: handleError,
  });
};
